import { useSelector } from 'react-redux';

import SelectorCumulativeInfoComponent from '../components/SelectorCumulativeInfoComponent';
import {
  getDimensionalPrecision,
  getDisplayScale,
  getDisplayUnits,
  getIsMeasurementToolActive,
  getNativeUnits,
  getSelectorCumulativeInfo,
} from '../data/reducer';

const SelectorCumulativeInfo = ({ isEnabled }) => {
  const cumulativeInfo = useSelector(getSelectorCumulativeInfo);
  const displayScale = useSelector(getDisplayScale);
  const displayUnits = useSelector(getDisplayUnits);
  const isMeasurementToolActive = useSelector(getIsMeasurementToolActive);
  const nativeUnits = useSelector(getNativeUnits);
  const dimensionalPrecision = useSelector(getDimensionalPrecision);

  return isEnabled && !isMeasurementToolActive ? (
    <SelectorCumulativeInfoComponent
      cumulativeInfo={cumulativeInfo}
      displayScale={displayScale}
      displayUnits={displayUnits}
      nativeUnits={nativeUnits}
      dimensionalPrecision={dimensionalPrecision}
    />
  ) : null;
};

export default SelectorCumulativeInfo;
